export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-check-d0d6bd20a4244f8c60fb4e57e2f70ccb.svg";